module.exports = __webpack_public_path__ + "img/he2.caf49841.png";